import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchFavoirateOffers } from "./actions";

export interface IAvailableOffer {
  banner: string;
  created_at?: string;
  id?: string;
  offer_description: any;
  offer_id: string;
  offer_type: number | string;
  uid?: string;
  updated_at?: string;
}

interface FavOffersState {
  isLoading: boolean;
  isError: boolean;
  favOffers: {
    basketBuilderOffers?: IAvailableOffer[];
    favouriteOffers?: IAvailableOffer[];
  };
  isAuthenticated: boolean;
  errorMessage: string;
  offersToBeAdded: any[];
}

const getInitialOffers = (): any[] => {
  if (typeof window !== "undefined") {
    try {
      return JSON.parse(sessionStorage.getItem("offers") || "[]");
    } catch {
      return [];
    }
  }
  return [];
};

const initialState: FavOffersState = {
  isLoading: false,
  isError: false,
  errorMessage: "",
  favOffers: {
    basketBuilderOffers: [],
    favouriteOffers: [],
  },
  isAuthenticated: false,
  offersToBeAdded: getInitialOffers(),
};
const fallbackErrorMessage = "Something went wrong. Please try again.";

export const FavoirateOffersSlice = createSlice({
  name: "favoirateOffersSlice",
  initialState,
  reducers: {
    resetOffersList: () => initialState,
    setFavoirateOffers: (
      state,
      action: PayloadAction<Partial<FavOffersState["favOffers"]>>
    ) => {
      state.favOffers = {
        // ...state.favOffers,
        ...action.payload,
      };
    },
    updateFavouriteOffers: (
      state,
      action: PayloadAction<IAvailableOffer[]>
    ) => {
      state.favOffers.favouriteOffers = action.payload;
    },
    offersToBeAddedFromStorage: (state, action) => {
      state.offersToBeAdded = action.payload;
    },
    offersRemovedFromStorage: (state, action) => {
      state.offersToBeAdded = action.payload;
    },
    resetOffersFromStorage: (state, action) => {
      state.offersToBeAdded = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(fetchFavoirateOffers.pending, (state: any) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(
      fetchFavoirateOffers.fulfilled,
      (state: any, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isError = false;
        state.favOffers = action?.payload;
        state.isAuthenticated = true;
      }
    );
    builder.addCase(fetchFavoirateOffers.rejected, (state: any, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action?.payload ?? fallbackErrorMessage;
    });
  },
});

export const {
  setFavoirateOffers,
  resetOffersList,
  updateFavouriteOffers,
  offersRemovedFromStorage,
  offersToBeAddedFromStorage,
  resetOffersFromStorage,
} = FavoirateOffersSlice.actions;

export const FavoirateOffersReducer = FavoirateOffersSlice.reducer;
